import { useQuery } from '@tanstack/react-query'
import { api, type SiteSettings } from '../../shared/api/api-client.ts'

export const siteContentKeys = {
  public: ['content', 'site-settings', 'public'] as const,
  admin: ['admin', 'site-settings'] as const,
}

export function usePublicSiteSettingsQuery() {
  return useQuery({
    queryKey: siteContentKeys.public,
    queryFn: api.getPublicSiteSettings,
    staleTime: 60_000,
  })
}

export function socialImageUrl(settings: SiteSettings): string | undefined {
  return settings.seo.socialImageAssetId
    ? api.publicAssetContentUrl(settings.seo.socialImageAssetId)
    : undefined
}
